import { combineReducers } from 'redux'
import { createReducer } from 'typesafe-actions'
import { galleryActions, GalleryData } from './gallery-actions'
import { FileData } from '../../../responses/files'
import { payloadReducer } from '../../../utils/redux-utils'
import { ID } from '../../../types/UtilityTypes'
import { RequestStatus } from '../../../responses/response'
import { Comment } from '../../../responses/comments'
import { taskActions } from '../../data/task/task-actions'
import { getId, idRemove } from '../../../utils/entity-utils'
import { historyActions } from '../history/history-actions'
import { ADTType, makeADT, ofType } from '@morphic-ts/adt'

export const GalleryEditState = makeADT('type')({
    none: ofType<{ type: 'none' }>(),
    delete: ofType<{ type: 'delete', file: FileData }>()
})

export interface GalleryState {
    open: boolean,
    current: FileData | null
    editState: ADTType<typeof GalleryEditState>,
    data: GalleryData,
    status: RequestStatus,
    ids: ID[],
    comments: Comment[],
}

export const galleryReducer = combineReducers<GalleryState>({
    open: createReducer<boolean>(false)
        .handleAction(galleryActions.open, () => true)
        .handleAction(galleryActions.close, () => false),
    current: createReducer<FileData | null>(null)
        .handleAction(galleryActions.open, (state, {payload}) => payload.current)
        .handleAction(galleryActions.setCurrent, payloadReducer),
    editState: createReducer<ADTType<typeof GalleryEditState>>(GalleryEditState.as.none({}))
        .handleAction(galleryActions.startDelete, (_, {payload}) => GalleryEditState.as.delete({file: payload}))
        .handleAction([galleryActions.delete.success, galleryActions.close, galleryActions.cancelEdit], () => GalleryEditState.as.none({})),
    data: createReducer<GalleryData>({type: 'none'})
        .handleAction(galleryActions.open, payloadReducer),
    status: createReducer(RequestStatus.INITIAL)
        .handleAction(galleryActions.open, () => RequestStatus.INITIAL)
        .handleAction(taskActions.comments.request, () => RequestStatus.FETCHING)
        .handleAction(taskActions.comments.success, () => RequestStatus.SUCCESS)
        .handleAction(taskActions.comments.failure, () => RequestStatus.FAILURE),
    ids: createReducer<ID[]>([])
        .handleAction(taskActions.comments.success, (_, action) => action.payload.comments.map(getId))
        .handleAction(historyActions.delete.success, (state, action) => idRemove(action.payload)(state)),
    comments: createReducer<Comment[]>([])
        .handleAction(galleryActions.setComments, payloadReducer)
})